export default __webpack_public_path__ + "static/media/diamond.a90fc387.png";